var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4951",
    "data-name": "Group 4951",
    transform: "translate(-35 -743)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17353",
    "data-name": "Rectangle 17353",
    width: 48,
    height: 48,
    transform: "translate(35 743)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4946",
    "data-name": "Group 4946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M0,0H39.984V39.984H0Z",
    transform: "translate(39 747.798)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M17.275,3a13.275,13.275,0,1,0,0,26.55H19.93v4.071c6.443-4.071,10.62-10.762,10.62-17.346A13.28,13.28,0,0,0,17.275,3Zm1.77,23.9h-3.54v-3.54h3.54Zm0-6.2h-3.54c0-5.753,5.31-5.31,5.31-8.85a3.54,3.54,0,0,0-7.08,0H10.2a7.08,7.08,0,0,1,14.16,0C24.355,16.275,19.045,16.718,19.045,20.7Z",
    transform: "translate(41.297 748.338)",
    fill: "#2d73c7",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M18.815,1a16.818,16.818,0,0,0-.885,33.612v6.372l2.531-1.221c9.08-4.372,15.169-13.187,15.169-21.948A16.83,16.83,0,0,0,18.815,1ZM21.47,35.161V31.09H18.815A13.275,13.275,0,1,1,32.09,17.815C32.09,24.417,27.913,31.108,21.47,35.161ZM17.045,24.9h3.54v3.54h-3.54ZM18.815,6.31a7.078,7.078,0,0,0-7.08,7.08h3.54a3.54,3.54,0,0,1,7.08,0c0,3.54-5.31,3.1-5.31,8.85h3.54c0-3.983,5.31-4.425,5.31-8.85A7.078,7.078,0,0,0,18.815,6.31Z",
    transform: "translate(39.758 746.798)",
    fill: "#2d73c7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.23307efbe039cc9b29b671d28a541a19.svg";
export { ForwardRef as ReactComponent };